import React, { useEffect, useRef, useState } from "react";
import ToggleButton from "./ToggleButton";

export default function FilterMenu({ showTraining, setShowTraining, showEvent, setShowEvent, selectedAthlete, setSelectedAthlete }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [athletes, setAthletes] = useState([]);
  const menuRef = useRef(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/athletes-list`)
      .then(res => res.json())
      .then(data => setAthletes(data))
      .catch(console.error);
  }, []);

  // TODO: click-outside for filter menu not yet working — menu visibility is
  // controlled via DOM (style.display in index.html) rather than React state.
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const selectedAthleteData = athletes.find(a => a._id === selectedAthlete);

  return (
    <div className="filter-menu" id="filterMenu" ref={menuRef}>
      <button className="menu-close" onClick={() => toggleFilterMenu()} aria-label="Close menu">
        ×
      </button>

      <label>Atleten:</label>
      <div className="athlete-select-row">
        {selectedAthleteData?.profilePhoto && (
          <img
            src={selectedAthleteData.profilePhoto}
            alt={selectedAthleteData.firstName}
            className="athlete-select-photo"
          />
        )}
        <select value={selectedAthlete} onChange={e => setSelectedAthlete(e.target.value)}>
          <option value="all">Alle atleten</option>
          {athletes.map(a => (
            <option key={a._id} value={a._id}>
              {a.displayName || a.name}
            </option>
          ))}
        </select>
      </div>

      <label>Evenement tonen:</label>
      <ToggleButton label="Evenement tonen" checked={showEvent} onChange={setShowEvent} />

      <label>Trainingen tonen:</label>
      <ToggleButton label="Trainingen tonen" checked={showTraining} onChange={setShowTraining} />
    </div>
  );
}
